module.exports = __webpack_public_path__ + "img/partner_eon.92448d11.png";